<template>
    <div>
        <p class="qs-500 message-body tw-leading-loose" :class="[ { '': mine }, { 'tw-text-black': !mine }, ]" v-html="body" ></p>
        <div v-if="message.image_preview" class="tw-max-w-xs tw-mb-2">
            <div>
                <img v-for="(image, i) in message.image_preview" :key="i" :src="image"/>
            </div>
        </div>
        <div class="images tw-max-w-xs tw-mb-2" v-if="message.attachments.length > 0">
            <lightbox :images="message.attachments" thumbnailSrc="url" src="url" customImageClass="message-attachment"></lightbox>
        </div>
    </div>
</template>

<script>
export default {
	name: 'MessageText',
	props: ['message', 'body', 'mine']
};
</script>

<style lang="scss">
    $light-blue: #D3EAFD;


    .images {
         img {
            width:100%;
            max-width: 20rem !important;
            max-height: 20rem !important;
            cursor:pointer;
            margin-top: 12px;
            @apply tw-rounded;

            &:hover {
                opacity:0.7;
            }
        }
    }

    .message-mine {
        background-color:$light-blue;
        color:#1A1301;
    }
</style>